import React from "react";
import PropTypes from "prop-types";

import { ProjectCampaignIcons, getProjectCampaignTitle } from "src/utils/constants/project-detail";

import styles from "./styles.module.css";

const CampaignCard = ({ campaign }) => {
  const icon = ProjectCampaignIcons[campaign.name];
  if (!icon) return null;

  return (
    <span className={styles.campaignBox}>
      {icon}
      <div className={styles.campaignTitle}>{getProjectCampaignTitle(campaign)}</div>
      <p className={styles.campaignDesc}>{campaign.description}</p>
    </span>
  );
};

CampaignCard.propTypes = {
  campaign: PropTypes.shape({
    name: PropTypes.string,
    campaignTitle: PropTypes.string,
    description: PropTypes.string,
    date: PropTypes.string,
  }),
};

export default CampaignCard;
